<template>
  <v-dialog      
    v-model="show"     
    :overlay="true"
    :persistent="persistent"
    max-width="600px"
    light       
    class="mt-4"           
  >   
    <v-card>
      <v-toolbar
        color="primary"
        dark
        class="text-h5"
      >
        Meddelanden
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row align="center" justify="center">
            <div
              v-for="alert in alerts"
              :key="alert.title"
              class="pb-2 pt-2" 
            > 
              <v-card :class="alert.force ? 'red lighten-1 theme--dark' : ''">
                <v-card-text :class="alert.force ? 'white--text' : ''">
                  <v-btn
                    v-if="alert.openDialog"
                    block
                    dark            
                    class="red darken-4 mb-4"
                    @click="alertGoto(alert.openDialog)"
                  >
                    {{ alert.title }}
                  </v-btn>
                  {{ alert.message }}
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </v-card-text>          
    </v-card>
  </v-dialog>
</template>
 

 <script> 
 import { SET_ALERTS_SHOWN} from '@/store/appMutations'    
 import { mapMutations } from 'vuex'
 import DialogMixin from '@/components/web/dialogs/DialogMixin'
 export default {
  name:'AlertDialog',
  components:{ },
  mixins: [ DialogMixin ],
  props: {
    alerts: {       
      type:Array,
      required: true }
  },
  data(){
    return {
      showAlert:false
    }
  },
  computed:{
    persistent(){      
      return this.alerts.some(al=>al.force)
    },
    showDialog:{
      get: function(){
        return this.showAlert
      },
      set:function(newValue){
        this.showAlert = newValue
      }
    }
  },  
  created(){
    this.showAlert = this.show
    console.log(this.alerts)
  }, 
  methods:{
     ...mapMutations({      
      setAlertsShown: SET_ALERTS_SHOWN
    }),
    alertGoto(to){
         this.$router.push({name:to})
         this.$emit('close')
         this.setAlertsShown(true)
    }
  }

 }
 </script>

 <style lang="scss" scoped>
  .ctr{
    background-color:white;
    padding:10%;
    
  }
  .v-dialog{
    top:8em!important
  }
</style>
